export default "__VITE_ASSET__DD3DXSO6__"